import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  ActivatedRoute,
  RouterModule,
} from '@angular/router';
import { Observable } from 'rxjs';
import { LayoutModule } from '../../../layout/layout.module';

interface WorkspaceMetric {
  label: string;
  value: string;
  tone: 'amber' | 'blue' | 'green' | 'violet';
}

interface WorkspaceSectionData {
  eyebrow: string;
  title: string;
  description: string;
  metrics: WorkspaceMetric[];
}

@Component({
  selector: 'app-workspace-section-page',
  standalone: true,
  imports: [
    CommonModule,
    LayoutModule,
    RouterModule,
  ],
  templateUrl: './workspace-section-page.component.html',
  styleUrl: './workspace-section-page.component.sass',
})
export class WorkspaceSectionPageComponent {
  public readonly pageData: Observable<WorkspaceSectionData> = this.route.data as Observable<WorkspaceSectionData>;

  public constructor(
    private route: ActivatedRoute,
  ) { }
}
